export const QueueRoutes = {
  QueueDashboard: '/queue/dashboard',
  QueueDashboardQuery: '/queue/dashboard/query',
  QueueSearch: '/queue/search',
  MyQueue: '/queue/myqueue',
  WorkTypes: '/queue/worktypes',
  Queue: '/queue/queuesetting',
  QueueView: '/queue/queueview/:queueID',
  NewQueueView: '/queue/newqueueview/:queueID',
  QueueWorkItemView: '/queue/queueworkitemview/:workitemID',
  CodefileMaintenance: '/queue/codefile',
  Calendar: '/queue/calendar',
  BatchImport: '/queue/batchimports',
  BatchImportDetail: '/queue/batchimport/:batchID',
  BatchImportDetailWorkItems: '/queue/batchimport/:batchID/:viewType',
  CopyAttachmentsToProperty: '/queue/copyattachmentstoproperty',
  WorkItemSearch: '/queue/workitemsearch',
};
